/**
 * A single label/value row used throughout PropertyDetailsModal and cards.
 */
const PropertyField = ({ label, value, children, valueClassName }) => (
  <div className="property-field" role="group" aria-label={label}>
    <span className="property-label">{label}:</span>
    <span className={`property-value${valueClassName ? ` ${valueClassName}` : ""}`}>
      {children ?? value ?? "N/A"}
    </span>
  </div>
);

export default PropertyField;
